import { useMutation } from "@tanstack/react-query";

import { deleteSavedPaymentMethod } from "checkout-query-client/api/delete-saved-payment-method";

export const useDeleteSavedPaymentMethod = (
  checkoutSessionToken: string,
  apiHost: string,
  version: string
) => {
  return useMutation({
    retry: 0,
    mutationFn: (paymentMethodId: string) =>
      deleteSavedPaymentMethod({
        checkoutSessionToken,
        apiHost,
        version,
        paymentMethodId,
      }),
  });
};
